import { gql } from 'graphql.macro';

export const getInvoiceBatchesTemplate = gql`
    query invoiceBatches($offset: Int, $limit: Int) {
        invoiceBatches(offset: $offset, limit: $limit) {
            hasMore
            batches {
                _id
                status
                invoiceCount
                customerCount
                totalOrderCount
                createdAt
                completedAt
                invoices {
                    _id
                    status
                    total {
                        currency
                        totalIncVat
                    }
                    deliveryAddress {
                        name
                    }
                }
                failedInvoices {
                    invoiceId
                    clinicName
                    errorMessage
                    provider
                }
            }
        }
    }
`;

export const getInvoiceBatchTemplate = gql`
    query invoiceBatch($id: MongoDbObjectId!) {
        invoiceBatch(id: $id) {
            _id
            status
            invoiceCount
            customerCount
            totalOrderCount
            createdAt
            completedAt
            invoices {
                _id
                invoiceNumber
                status
                total {
                    currency
                    totalIncVat
                }
                deliveryAddress {
                    name
                }
                dentist {
                    name {
                        firstName
                        lastName
                    }
                }
                processingErrorMessage
                orders
            }
            failedInvoices {
                invoiceId
                invoiceNumber
                clinicName
                errorMessage
                provider
            }
        }
    }
`;
